import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { HTTPCONSTANTS } from '../http/http-constants';
import { MarketPulseResponse } from '../models/market-pulse.model';

/**
 * Thin client for GET /api/marketpulse. Shares a single in-flight request across all
 * /sell page consumers (pulse-rail + live-market + flow Stage 04) so we hit the API
 * once per page load. Errors resolve to null so callers can fall back silently.
 */
@Injectable({ providedIn: 'root' })
export class MarketPulseService {
  private cached$: Observable<MarketPulseResponse | null> | null = null;

  constructor(private http: HttpClient) {}

  getMarketPulse(): Observable<MarketPulseResponse | null> {
    if (this.cached$) return this.cached$;
    const url = `${HTTPCONSTANTS.dataApiProtocol}${HTTPCONSTANTS.dataApiBaseAddress}/marketpulse`;
    this.cached$ = this.http.get<MarketPulseResponse>(url).pipe(
      catchError((err) => {
        console.error('MarketPulse fetch failed:', err?.status ?? err?.message ?? err);
        return of(null);
      }),
      shareReplay(1),
    );
    return this.cached$;
  }
}
